import { render, staticRenderFns } from "./AdminSettingIpRestrictionPopup.vue?vue&type=template&id=a4add364&scoped=true&"
import script from "./AdminSettingIpRestrictionPopup.vue?vue&type=script&lang=js&"
export * from "./AdminSettingIpRestrictionPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingIpRestrictionPopup.vue?vue&type=style&index=0&id=a4add364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4add364",
  null
  
)

export default component.exports